import React from "react";
import { FiveXTSScore } from "../../models/reports";
import { useRecoilValue } from "recoil";
import { PatientState } from "../../data/atoms";
import { convertDOBintoAge } from "../../utils/sharedFunction";
import CustomBarGraph from "../Graphs/CustomBarGraph";

interface Props {
  score: FiveXTSScore;
}
const Five_X_Sit_Stand_Test: React.FC<Props> = ({ score }) => {
  const patientInfo = useRecoilValue(PatientState);

  let overallOption = {
    graphName: "TotalTime",
    graphSVG: (
      <svg
        width="47"
        height="47"
        viewBox="0 0 47 47"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_7280_3165)">
          <path
            d="M25.2605 6.45947V5.95947H24.7605H22.1605H21.6605V6.45947V20.931V21.247L21.9459 21.3826L31.3394 25.8471L31.791 26.0617L32.0057 25.6102L33.1218 23.2619L33.3364 22.8103L32.8848 22.5956L25.2605 18.972V6.45947Z"
            fill="white"
            stroke="white"
          />
          <circle cx="23.5" cy="19.5" r="18.5" fill="black" />
          <path
            d="M23.5 0C12.7305 0 4 8.73047 4 19.5C4 30.2695 12.7305 39 23.5 39C34.2695 39 43 30.2695 43 19.5C43 8.73047 34.2695 0 23.5 0ZM23.5 36.4C14.1664 36.4 6.6 28.8336 6.6 19.5C6.6 10.1664 14.1664 2.6 23.5 2.6C32.8336 2.6 40.4 10.1664 40.4 19.5C40.4 28.8336 32.8336 36.4 23.5 36.4Z"
            fill="black"
          />
          <path
            d="M25.2605 6.45947V5.95947H24.7605H22.1605H21.6605V6.45947V20.931V21.247L21.9459 21.3826L31.3394 25.8471L31.791 26.0617L32.0057 25.6102L33.1218 23.2619L33.3364 22.8103L32.8848 22.5956L25.2605 18.972V6.45947Z"
            fill="white"
            stroke="white"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_7280_3165"
            x="0"
            y="0"
            width="47"
            height="47"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_7280_3165"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_7280_3165"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    ),
    graphTitle: "Total Time",
    graphTitleDesc: "",
    graphNormValue: 0,
    isgraphNorm: false,
    graphActualValue: [score?.overall / 1000],
    graphActualValueLabel: [`${(score?.overall / 1000).toPrecision(2)}`],
    graphRange: [10, 30, 50, 70],
    graphRangeLabel: ["10", "30", "50", "70"],
    graphNoLines: [],
    minMax: false,
    graphUnit: "Seconds",
    graphAge: convertDOBintoAge(new Date(patientInfo?.dob)),
  };
  let timePerRepOption = {
    graphName: "TimePerRep",
    graphSVG: (
      <svg
        width="47"
        height="47"
        viewBox="0 0 47 47"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_7280_771)">
          <path
            d="M16.5 15V3C9.5968 3 4 8.37293 4 15C4 21.6271 9.5968 27 16.5 27C23.4032 27 29 21.6271 29 15H16.5Z"
            fill="black"
          ></path>
        </g>
        <g filter="url(#filter1_d_7280_771)">
          <path d="M20 0V12H32C32 5.41714 26.5829 0 20 0Z" fill="black"></path>
        </g>
        <defs>
          <filter
            id="filter0_d_7280_771"
            x="0"
            y="3"
            width="33"
            height="32"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            ></feColorMatrix>
            <feOffset dy="4"></feOffset>
            <feGaussianBlur stdDeviation="2"></feGaussianBlur>
            <feComposite in2="hardAlpha" operator="out"></feComposite>
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
            ></feColorMatrix>
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_7280_771"
            ></feBlend>
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_7280_771"
              result="shape"
            ></feBlend>
          </filter>
          <filter
            id="filter1_d_7280_771"
            x="16"
            y="0"
            width="20"
            height="20"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            ></feColorMatrix>
            <feOffset dy="4"></feOffset>
            <feGaussianBlur stdDeviation="2"></feGaussianBlur>
            <feComposite in2="hardAlpha" operator="out"></feComposite>
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
            ></feColorMatrix>
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_7280_771"
            ></feBlend>
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_7280_771"
              result="shape"
            ></feBlend>
          </filter>
        </defs>
      </svg>
    ),
    graphTitle: "Time Per Rep",
    graphTitleDesc: "",
    graphNormValue: 0,
    isgraphNorm: false,
    graphActualValue: [
      ...score?.repetitions.map((rep) => {
        return rep.time / 1000;
      }),
    ],
    graphActualValueLabel: [
      ...score?.repetitions.map((rep) => {
        return (rep.time / 1000).toPrecision(2).toString();
      }),
    ],
    graphRange: [0, 5, 10, 15, 20],
    graphRangeLabel: ["0", "5", "10", "15", "20"],
    graphNoLines: [
      ...score?.repetitions.map((rep) => {
        return (rep.index + 1).toString();
      }),
    ],
    minMax: false,
    graphUnit: "Seconds",
    graphAge: convertDOBintoAge(new Date(patientInfo?.dob)),
  };

  return (
    <>
      {score && score?.overall != 0 && !isNaN(score?.overall) && (
        <CustomBarGraph options={overallOption} />
      )}
      {score && score?.repetitions.length != 0 && (
        <CustomBarGraph options={timePerRepOption} />
      )}
    </>
  );
};

export default Five_X_Sit_Stand_Test;
